import type {SxProps, Theme} from '@mui/material';

/**
 * Shared `fullScreen`-aware style factories for `ImagePreviewModal` and its
 * sub-components. Centralising these keeps the `fullScreen ? A : B`
 * responsive rules in one place instead of duplicated inline across every
 * styled element.
 */

export const getPreviewRootSx = (fullScreen: boolean, hasActiveAction: boolean): SxProps<Theme> => ({
  position: 'relative',
  bgcolor: hasActiveAction ? 'background.paper' : 'common.black',
  height: fullScreen ? '100%' : undefined,
  display: fullScreen ? 'flex' : undefined,
  flexDirection: fullScreen ? 'column' : undefined,
});

export const getActionStageSx = (fullScreen: boolean): SxProps<Theme> => ({
  p: fullScreen ? 0 : 2,
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: fullScreen ? 'hidden' : 'auto',
});

export const getPreviewImageSx = (fullScreen: boolean): SxProps<Theme> => ({
  display: 'block',
  width: '100%',
  height: fullScreen ? '100%' : undefined,
  maxHeight: fullScreen ? undefined : '80vh',
  flex: fullScreen ? 1 : undefined,
  minHeight: 0,
  objectFit: 'contain',
});

